import type { ReactNode } from "react"
import { Spin } from "antd"

type Props = {
  sidebar: ReactNode
  children: ReactNode
  isBusy?: boolean
  wrapperClassName?: string
  mainClassName?: string
}

export default function StepsMainLayout({
  sidebar,
  children,
  isBusy = false,
  wrapperClassName = "flex flex-col gap-2 h-full lg:flex-row",
  mainClassName = "flex-1 min-w-0 bg-white rounded-md py-4 px-4 md:py-6 md:px-6 flex flex-col min-h-screen overflow-hidden relative",
}: Props) {
  return (
    <div className={wrapperClassName}>
      {sidebar}

      <main className={mainClassName}>
        {/* {isBusy && (
          <div className="absolute inset-0 z-10 flex items-center justify-center bg-white/80 rounded-md pointer-events-auto">
            <Spin />
          </div>
        )} */}

        <div
          className={`flex flex-col flex-1 min-h-0 overflow-hidden ${
            isBusy ? "pointer-events-none select-none" : ""
          }`}
        >
          {children}
        </div>
      </main>
    </div>
  )
}
